import script from "./QRScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./QRScanner.vue?vue&type=script&setup=true&lang=js"

import "./QRScanner.vue?vue&type=style&index=0&id=31923e52&scoped=true&lang=css"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31923e52"]])

export default __exports__